import * as S from "./styles";

type Props = {
  height?: number | string;
  width?: number | string;
  rounded?: boolean;
  margin?: number;
  marginHorizontal?: number;
  style?: React.CSSProperties | undefined;
};

function Skeleton({
  width = "100%",
  height = "100%",
  rounded = false,
  style,
}: Props) {
  return <S.Wrapper style={{ width, height, ...style }} rounded={rounded} />;
}

export { Skeleton };
